import { Building2 } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { HOTELS, slug } from "../lib/constants";

export const HotelSelect = ({ value, onChange, allowAll = false, testId = "hotel-select", placeholder = "Select property" }) => (
  <Select value={value || undefined} onValueChange={onChange}>
    <SelectTrigger data-testid={testId} className="h-10 min-w-[220px] rounded-full bg-white/90 border-emerald-900/15 font-semibold text-emerald-950">
      <Building2 className="h-4 w-4 text-amber-600 mr-1 shrink-0" />
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent className="bg-white">
      {allowAll && <SelectItem value="All" data-testid={`${testId}-option-all`}>All Properties</SelectItem>}
      {HOTELS.map((h) => (
        <SelectItem key={h} value={h} data-testid={`${testId}-option-${slug(h)}`}>{h}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);
